import { ActionStatus } from '@/application/types';
import { AddressCorrectionState } from '../types';

export const addressCorrectionStateDefaults: AddressCorrectionState = {
  invalidAddresses: [],
  limit: 20,

  getInvalidAddressesStatus: ActionStatus.None,
  getInvalidAddressStatus: ActionStatus.None,
  correctAddressesStatus: ActionStatus.None,
};
